import { useEffect } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { SITE_FOOTER } from "../platform_spaces/shell/siteFooterContent";
import {
  CORPORATE_COMPANY,
  CORPORATE_NAV,
} from "./CorporatePortalContent";
import "./CorporatePortalLayout.css";
import "./CorporatePortalPages.css";

export function CorporatePortalLayout() {
  const location = useLocation();

  useEffect(() => {
    document.title = `${CORPORATE_COMPANY.shortName} · ${CORPORATE_COMPANY.fullName}`;
  }, [location.pathname]);

  return (
    <div className="corporate-portal">
      <header className="corporate-portal-header">
        <div className="corporate-portal-header-inner">
          <Link to="/" className="corporate-portal-brand">
            <div className="corporate-portal-brand-mark">MV</div>
            <div className="corporate-portal-brand-text">
              <span className="corporate-portal-brand-name">{CORPORATE_COMPANY.shortName}</span>
              <span className="corporate-portal-brand-tagline">人工智能 · 产业升级</span>
            </div>
          </Link>
          <nav className="corporate-portal-nav">
            {CORPORATE_NAV.map((item) => {
              const active =
                item.path === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(item.path);
              return (
                <Link
                  key={item.key}
                  to={item.path}
                  className={`corporate-portal-nav-link${active ? " active" : ""}`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </header>

      <main className="corporate-portal-main">
        <Outlet />
      </main>

      <footer className="corporate-portal-footer">
        <div className="corporate-portal-footer-inner">
          <div>
            <div className="corporate-portal-footer-title">{CORPORATE_COMPANY.fullName}</div>
            <div style={{ lineHeight: 1.8 }}>{CORPORATE_COMPANY.slogan}</div>
          </div>
          {CORPORATE_COMPANY.email ? (
            <div>
              <div className="corporate-portal-footer-title">联系方式</div>
              <div style={{ lineHeight: 1.8 }}>{CORPORATE_COMPANY.email}</div>
            </div>
          ) : null}
        </div>
        <div className="corporate-portal-footer-copy">
          © {new Date().getFullYear()} {CORPORATE_COMPANY.fullName} 版权所有
          {SITE_FOOTER.icpLabel ? (
            <>
              {" · ICP 许可证："}
              <a
                href={SITE_FOOTER.icpQueryUrl}
                target="_blank"
                rel="noreferrer noopener"
                style={{ color: "rgba(255, 255, 255, 0.65)", textDecoration: "none" }}
              >
                {SITE_FOOTER.icpLabel}
              </a>
            </>
          ) : null}
        </div>
      </footer>
    </div>
  );
}
